/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Original_Text_Preview_Aria_LabelInputs */

const en_event_original_text_preview_aria_label = /** @type {(inputs: Event_Original_Text_Preview_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Original text preview`)
};

const fr_event_original_text_preview_aria_label = /** @type {(inputs: Event_Original_Text_Preview_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apercu du texte original`)
};

const de_event_original_text_preview_aria_label = /** @type {(inputs: Event_Original_Text_Preview_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Originaltextvorschau`)
};

const it_event_original_text_preview_aria_label = /** @type {(inputs: Event_Original_Text_Preview_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anteprima del testo originale`)
};

const ru_event_original_text_preview_aria_label = /** @type {(inputs: Event_Original_Text_Preview_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предварительный просмотр исходного текста`)
};

const es_event_original_text_preview_aria_label = /** @type {(inputs: Event_Original_Text_Preview_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vista previa del texto original`)
};

const zh_cn2_event_original_text_preview_aria_label = /** @type {(inputs: Event_Original_Text_Preview_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`原文预览`)
};

const ja_event_original_text_preview_aria_label = /** @type {(inputs: Event_Original_Text_Preview_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`元のテキストのプレビュー`)
};

const hi_event_original_text_preview_aria_label = /** @type {(inputs: Event_Original_Text_Preview_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मूल पाठ पूर्वावलोकन`)
};

const pt_pt2_event_original_text_preview_aria_label = /** @type {(inputs: Event_Original_Text_Preview_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pré-visualização do texto original`)
};

/**
* | output |
* | --- |
* | "Original text preview" |
*
* @param {Event_Original_Text_Preview_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_original_text_preview_aria_label = /** @type {((inputs?: Event_Original_Text_Preview_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Original_Text_Preview_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_original_text_preview_aria_label(inputs)
	if (locale === "de") return de_event_original_text_preview_aria_label(inputs)
	if (locale === "it") return it_event_original_text_preview_aria_label(inputs)
	if (locale === "ru") return ru_event_original_text_preview_aria_label(inputs)
	if (locale === "es") return es_event_original_text_preview_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_event_original_text_preview_aria_label(inputs)
	if (locale === "ja") return ja_event_original_text_preview_aria_label(inputs)
	if (locale === "hi") return hi_event_original_text_preview_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_event_original_text_preview_aria_label(inputs)
	return en_event_original_text_preview_aria_label(inputs)
});